import { Visibility } from '@mui/icons-material'
import { GridActionCellItem } from '../../components/common/kc-table/components'
import dayjs from 'dayjs'
import { Chip, Typography } from '@mui/material'
import { formatDateTime, formatTimeRemaining } from '../HL7historyLogs/utils'

export const getColumns = ({ onView }) => {
  const columns = [
    {
      field: 'orderNumber',
      headerName: 'Order Number',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
            }}
          >
            {params?.value || '-'}
          </Typography>
        )
      },
    },
    {
      field: 'kproTeamId',
      headerName: 'Facility Name',
      minWidth: 200,
      flex: 1,
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        return (
          <Chip
            size="small"
            variant='outlined'
            label={params?.value === 0 ? 'Failed' : 'Success'}
            color={params?.value === 0 ? 'error' : 'success'}
          />
        )
      },
    },
    {
      field: 'retryCount',
      headerName: 'Retry Count',
      minWidth: 100,
      flex: 1,
      renderCell: (params) => {
        return (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
            }}
          >
            {params?.value || 0}
          </Typography>
        )
      },
    },
    {
      field: 'mrn',
      headerName: 'MRN',
      minWidth: 100,
      flex: 1,
    },
    {
      field: 'recordedAt',
      headerName: 'Recorded At',
      minWidth: 200,
      flex: 1,
      type: 'dateTime',
      renderCell: (params) => params?.value ? formatDateTime(params.value) : 'N/A',
      sortComparator: (v1, v2) => {
        return dayjs(v1).isAfter(dayjs(v2)) ? 1 : -1
      },
    },
    {
      field: 'sentAt',
      headerName: 'Sent At',
      minWidth: 200,
      flex: 1,
      type: 'dateTime',
      renderCell: (params) => params?.value ? formatDateTime(params.value) : 'N/A',
      sortComparator: (v1, v2) => {
        return dayjs(v1).isAfter(dayjs(v2)) ? 1 : -1
      },

    },
    {
      field: 'processingTime',
      headerName: 'Processing Time',
      minWidth: 100,
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <Typography
            variant="body2"
            sx={{
              fontWeight: 700,
            }}
          >
            {

              formatTimeRemaining(row.recordedAt, row.sentAt) || 'N/A'

            }


          </Typography>
        )
      },
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: 'Actions',
      minWidth: 120,
      cellClassName: 'actions',
      getActions: ({ id }) => {
        return [
          <GridActionCellItem
            icon={<Visibility />}
            label="View Logs"
            className="textPrimary"
            onClick={onView?.(id)}
            color="inherit"
          />,
        ]
      },
    },
  ]
  return columns
}
